import { useQuery } from '@tanstack/react-query';

import { Gateway } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/gateway/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    restricted_membership_type?: string;
    parkingId: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Gateway>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 30,
        ...config,
    });

export { RESOURCE as LIST_GATEWAYS_RESOURCE, useQueryHook as useListGateways };
